import { render, staticRenderFns } from "./OrderDetailCombookBindingRow.vue?vue&type=template&id=5575f724&"
import script from "./OrderDetailCombookBindingRow.vue?vue&type=script&lang=js&"
export * from "./OrderDetailCombookBindingRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports